<template>
  <el-dialog title="Gerar DIMOB" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="300px">
    <el-form :model="dimob" :rules="validacao" ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-select style="width:100%;" v-model="dimob.formato">
              <el-option key="PDF" label="Gerar PDF" value="PDF"/>
              <el-option key="XLS" label="Gerar XLS" value="XLS"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Ano Base" prop="anoBase">
            <el-input
              auto-complete="off"
              v-model="dimob.anoBase"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gerarDimobHandler" type="primary" size="small" round class="btn-box-shadow">Gerar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions } from "vuex";

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      dimob: {
        anoBase: undefined,
        formato: 'PDF'
      },

      validacao: {
        anoBase: [{ required: true }]
      }
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", [
      "gerarDimob",
      ]),
    gerarDimobHandler() {
      this.$refs["form"].validate(elFormItemAreValid => {
        const formIsInvalid = !elFormItemAreValid;
        if(formIsInvalid) {
          this.$message.warning("Insira os dados obrigatórios.")
          return;
        }
          let payload = { 
            nome: "DIMOB",
            aluguel: { id: this.aluguel.id },
            anoBase: this.dimob.anoBase,
            xls: this.dimob.formato === 'XLS'
          };

          this.showLoading();
          this.gerarDimob(payload)
          .then((response) => {
            this.hideLoading();
            switch(response.status) {
              case "SUCESSO":
                window.open(response.mensagem, '_blank');  
                break;
            }
          }).catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível comunicar-se com o servidor");
          });
      });
    },
    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
